/**
 * @description Capitalize first letter, ex: name -> Name
 * @param {string} string
 * @return {string}
 */
export const capitalizeFirstLetter = (string: string) => string.charAt(0).toUpperCase() + string.slice(1)

/**
 * @description check if first character of string is not a space or '
 * @param {string} string
 * @returns {Boolean}
 */
export const isErrorOnFirstCharacter = (string: string) => {
    if (string && (string.charAt(0) === '-' || string.charAt(0) === ' ')) return true
    return false
}

/**
 * @description check if we have space or apostrophe doubled or combined in a specific string
 * @param {string} string
 * @returns {Boolean}
 */
export const isSpaceOrApostropheDoubledOrCombinedInString = (string: string) => {
    if (string && (string.match("''") || string.match("' ") || string.match(" '") || string.match('  '))) return true
    return false
}

/**
 * @description clean string of all accents and diacritics.
 * @param {String} string
 * @returns {String}
 */
export const cleanAccentsAndDiacritics = (string: string): string =>
    string.normalize('NFD').replace(/[\u0300-\u036f]/g, '')

export const uneditableRppsRelatedFieldInfo = "Champ non modifiable provenant de l'annuaire santé"
